import { reportFilterActions } from '@mode/report-viewer/domain';
import { Map } from 'immutable';
import { QueryActionType } from '~/actions/query.actions';

import { AppState, TransientEditorState } from '@mode/legacy/types-app-state';
import { ReducerTree } from '@mode/legacy/util-domain';
import { EditorActionType } from '../../actions/editor-actions';
import { Actions } from '../../actions/index';
import { generatePreviewTableQuery } from '../../lib/click-to-preview-helpers';

export const initialTransientEditorState: TransientEditorState = {
  isFilterPanelOpen: false,
  cursorPositions: Map(),
};

export function cursorPositionsReducer(
  state = initialTransientEditorState.cursorPositions,
  action: Actions
): TransientEditorState['cursorPositions'] {
  switch (action.type) {
    case QueryActionType.BatchUpdateQueries: {
      const newQueries = action.payload.filter((q) => q.mapping_id != null);
      newQueries.forEach((query) => {
        state = state.set(query.token, state.get(query.mapping_id));
      });

      return state;
    }
    case EditorActionType.UpdateQueryEditor: {
      const queryToken = action.payload.selectedQueryToken;
      const current = state.get(queryToken);
      if (
        !current ||
        action.payload.selectionLead !== current.selectionLead ||
        action.payload.selectionAnchor !== current.selectionAnchor
      ) {
        const { selectionLead, selectionAnchor } = action.payload;
        return state.set(queryToken, { selectionLead, selectionAnchor });
      }
      break;
    }
    case EditorActionType.InsertQueryText: {
      const selectionStart = action.payload.selectionStart;
      const pos = selectionStart + action.payload.text.length;
      return state.set(action.payload.selectedQueryToken, {
        selectionLead: pos,
        selectionAnchor: pos,
      });
    }
    case EditorActionType.RunPreviewTableQuery: {
      const previewQueryText = generatePreviewTableQuery(action.payload);
      return state.set(action.payload.selectedQueryToken, {
        selectionLead: 0,
        selectionAnchor: previewQueryText.length,
      });
    }
  }

  return state;
}

export function isFilterPanelOpenReducer(
  state = initialTransientEditorState.isFilterPanelOpen,
  action: Actions
): TransientEditorState['isFilterPanelOpen'] {
  switch (action.type) {
    case reportFilterActions.loadReportFiltersSuccess.type:
      return action.resources != null && action.resources.length > 0;
    case reportFilterActions.createReportFilterSuccess.type:
      return true;
    case EditorActionType.ToggleFilterPanel:
      return !state;
    case EditorActionType.OverrideFilterPanel:
      return action.isOpen;
  }

  return state;
}

export const TransientEditorReducer: ReducerTree<AppState, TransientEditorState, Actions> = {
  isFilterPanelOpen: isFilterPanelOpenReducer,
  cursorPositions: cursorPositionsReducer,
};
